
<div class="p-grid max-height select-lang">
  <div class="p-col-12">
    <Dropdown
      class="p-card"
      v-model="selectedCountry"
      :options="countries"
      optionLabel="name"
      placeholder="Select a country"
      @change="selectLang"
    >
      <template #value="slotProps">
        <div class="country-item" v-if="slotProps.value">
          <img v-if="slotProps.value.flag===true" class="flag" :src="getFlagImage(slotProps.value.name.toLowerCase(), slotProps)" />
          <span v-if="showLabel" class="country-name">{{slotProps.value.name}}</span>
          <img class="icon" v-if="slotProps.value.icon===true" src="#"/>
          <i v-if="slotProps.value.icon!==''" class="material-icons icon"> {{ slotProps.value.icon }}</i>
        </div>
      </template>
      <template #option="slotProps">
        <div class="country-item">
          <img v-if="slotProps.option.flag===true" class="flag" :src="getFlagImage(slotProps.option.name.toLowerCase(), slotProps)" />
          <span class="country-name">{{slotProps.option.name}}</span>
        </div>
      </template>
    </Dropdown>
  </div>
</div>